export const messages = {
	formal: {
		name: {
			label: 'Teljes neve',
			requiredError: 'Kérjük, adja meg a teljes nevét!',
			requiredErrorBusiness: 'Kérjük, adja meg a kapcsolattartó nevét!',
			requiredErrorCaring: 'Kérjük, adja meg a munkáltató nevét!',
			requiredErrorEmployee: 'Kérjük, adja meg a munkavállaló nevét!',
			patternError: 'Kérjük, ellenőrizze a megadott nevet!',
			patternErrorCaring: 'Kérjük, ellenőrizze a munkáltató nevét!',
			patternErrorEmployee: 'Kérjük, ellenőrizze a munkavállaló nevét!',
		},
		phoneNumber: {
			label: 'Telefonszáma',
			requiredError: 'Kérjük, adja meg telefonszámát!',
			requiredErrorCaring: 'Kérjük, adja meg a munkáltató telefonszámát!',
			requiredErrorEmployee: 'Kérjük, adja meg a munkavállaló telefonszámát!',
			patternError: 'Kérjük, ellenőrizze a telefonszámát!',
			patternErrorCaring: 'Kérjük, ellenőrizze a munkáltató telefonszámát!',
			patternErrorEmployee: 'Kérjük, ellenőrizze a munkavállaló telefonszámát!',
		},
		email: {
			label: 'E-mail címe',
			requiredError: 'Kérjük, adja meg az e-mail címét!',
			requiredErrorBusiness: 'Kérjük, adja meg a kapcsolattartó e-mail címét!',
			patternError: 'Kérjük, ellenőrizze a megadott e-mail címet!',
		},
		captcha: {
			requiredError: 'Kérjük, adja meg a megjelenő kódot!',
			patternError: 'Kérjük, ellenőrizze a megjelenő kódot!',
		},
		time: {
			label: 'Mikor kereshetjük',
		},
		callbackSubject: {
			requiredError: 'Kérjük, adja meg a tárgyat!',
			placeholder: 'Kérjük, válasszon',
		},
		lookForYou: 'Kollégánk hamarosan keresni fogja Önt',
		unavailable: 'Sajnos jelenleg nem tud',
		later: 'Kérjük nézzen vissza később!',
		companyName: {
			label: 'Vállalkozás neve',
			error: {
				required: 'Kérjük, adja meg a vállalkozás nevét!',
				pattern: 'Kérjük, ellenőrizze a megadott vállalkozás nevet!',
				minlength: 'A mező kitöltése nem megfelelő!',
			},
		},
		county: {
			label: 'Lakóhely szerinti megye',
			placeholder: 'Kérjük válasszon megyét!',
			error: {
				required: 'Kérjük, válasszon megyét!',
			},
		},
		taxNumber: {
			label: 'Adószáma / Adóazonosító jele',
			addon: '(Opcionális)',
			tooltip: 'Vállalkozások esetén adószám (pl. 13000222-0-22), egyéni vállalkozók esetén adóazonosító jel (pl. 8220329920).',
			error: {
				required: 'Kérjük, adja meg az adószámot vagy adóazonosító jelet!',
				pattern: {
					id: 'Kérjük, ellenőrizze az adóazonosító jelet!',
					number: 'Kérjük, ellenőrizze az adószámot!',
				},
			},
		},
		zipCode: {
			label: 'Irányítószám',
			tooltip: 'Ahol a hitelügyintézést végezné. Lehet ez a jelenlegi lakhelye vagy a megvásárolni kívánt ingatlan címe is.',
			error: {
				required: 'Kérjük, adja meg irányítószámát!',
				requiredCaring: 'Kérjük, adja meg a munkáltató irányítószámát!',
				requiredEmployee: 'Kérjük, adja meg a munkavállaló irányítószámát!',
				pattern: 'Kérjük, ellenőrizze a megadott irányítószámot!',
				patterCaring: 'Kérjük, ellenőrizze a munkáltató irányítószámát!',
				patterEmployee: 'Kérjük, ellenőrizze a munkavállaló irányítószámát!',
			},
		},
		feedback: {
			error: {
				title: 'Sajnáljuk!',
				text: 'Sajnos jelenleg nem tud visszahívást kérni a mi hibánkból, de már dolgozunk rajta. Kérjük nézzen vissza később!',
			},
			success: {
				title: 'Köszönjük!',
				text: 'Kollégánk hamarosan keresni fogja Önt a részletekkel kapcsolatban a következő <br /> telefonszámon: <strong>+36 {phoneNumber}.</strong>',
				coupon: '<br /> Az online kupont kiküldtük a <strong>{email} e-mail címre.</strong>',
			},
		},
		disclaimer: {
			business:
				'Hozzájárulok ahhoz, hogy adataimat az <a href="{url}" target="_blank">Adatkezelési tájékoztató</a> szerint a kereskedelmi tevékenység végzéséhez használják fel.',
			private:
				'Hozzájárulok ahhoz, hogy adataimat az <a href="{url}" target="_blank">Adatkezelési tájékoztató</a> szerint az online hitelügyintézéshez használják fel.',
		},
		agreement:
			'Elolvastam és elfogadom a <a href="{url}" target="_blank">Felhasználási feltételeket</a> és az <a href="{url2}" target="_blank">Adatkezelési tájékoztatót</a>.',
		recaptcha: {
			error: 'Kérjük, ellenőrizze, hogy nem-e robot!',
			expired: 'A reCAPTCHA lejárt. Kérjük, jelölje be újra!',
		},
	},
	casual: {
		name: {
			label: 'Teljes neved',
			requiredError: 'Kérjük, add meg a teljes neved!',
			requiredErrorBusiness: 'Kérjük, add meg a kapcsolattartó nevét!',
			requiredErrorCaring: 'Kérjük, add meg a munkáltató nevét!',
			requiredErrorEmployee: 'Kérjük, add meg a munkavállaló nevét!',
			patternError: 'Kérjük, ellenőrizd a megadott nevet!',
			patternErrorCaring: 'Kérjük, ellenőrizd a munkáltató nevét!',
			patternErrorEmployee: 'Kérjük, ellenőrizd a munkavállaló nevét!',
		},
		phoneNumber: {
			label: 'Telefonszámod',
			requiredError: 'Kérjük, add meg telefonszámod!',
			requiredErrorCaring: 'Kérjük, add meg a munkáltató telefonszámát!',
			requiredErrorEmployee: 'Kérjük, add meg a munkavállaló telefonszámát!',
			patternError: 'Kérjük, ellenőrizd a telefonszámod!',
			patternErrorCaring: 'Kérjük, ellenőrizd a munkáltató telefonszámát!',
			patternErrorEmployee: 'Kérjük, ellenőrizd a munkavállaló telefonszámát!',
		},
		email: {
			label: 'E-mail címed',
			requiredError: 'Kérjük, add meg az e-mail címed!',
			requiredErrorBusiness: 'Kérjük, add meg a kapcsolattartó e-mail címét!',
			patternError: 'Kérjük, ellenőrizd a megadott e-mail-címet!',
		},
		captcha: {
			requiredError: 'Kérjük, add meg a megjelenő kódot!',
			patternError: 'Kérjük, ellenőrizd a megjelenő kódot!',
		},
		time: {
			label: 'Mikor kereshetünk',
		},
		callbackSubject: {
			requiredError: 'Kérjük, add meg a tárgyat!',
			placeholder: 'Kérjük, válassz',
		},
		lookForYou: 'Kollégánk hamarosan keresni fog téged',
		unavailable: 'Sajnos jelenleg nem tudsz',
		later: 'Kérjük nézz vissza később!',
		companyName: {
			label: 'Vállalkozás neve',
			error: {
				required: 'Kérjük, add meg a vállalkozás nevét!',
				pattern: 'Kérjük, ellenőrizd a megadott vállalkozás nevét!',
				minlength: 'A mező kitöltése nem megfelelő!',
			},
		},
		county: {
			label: 'Lakóhely szerinti megye',
			placeholder: 'Kérjük, válassz megyét!',
			error: {
				required: 'Kérjük, válassz megyét!',
			},
		},
		taxNumber: {
			label: 'Adószámod / Adóazonosító jeled',
			addon: '(Opcionális)',
			tooltip: 'Vállalkozások esetén adószám (pl. 13000222-0-22), egyéni vállalkozók esetén adóazonosító jel (pl. 8220329920).',
			error: {
				required: 'Kérjük, add meg az adószámod vagy adóazonosító jeled!',
				pattern: {
					id: 'Kérjük, ellenőrizd az adóazonosító jelet!',
					number: 'Kérjük, ellenőrizd az adószámot!',
				},
			},
		},
		zipCode: {
			label: 'Irányítószám',
			tooltip: 'Ahol a hitelügyintézést végeznéd. Lehet ez a jelenlegi lakhelyed vagy a megvásárolni kívánt ingatlan címe is.',
			error: {
				required: 'Kérjük, add meg irányítószámot!',
				requiredCaring: 'Kérjük, add meg a munkáltató irányítószámát!',
				requiredEmployee: 'Kérjük, add meg a munkavállaló irányítószámát!',
				pattern: 'Kérjük, ellenőrizd a megadott irányítószámot!',
				patterCaring: 'Kérjük, ellenőrizd a munkáltató irányítószámát!',
				patterEmployee: 'Kérjük, ellenőrizd a munkavállaló irányítószámát!',
			},
		},
		feedback: {
			error: {
				title: 'Sajnáljuk!',
				text: 'Sajnos jelenleg nem tudsz visszahívást kérni a mi hibánkból, de már dolgozunk rajta. Kérjük nézz vissza később!',
			},
			success: {
				title: 'Köszönjük!',
				text: 'Kollégánk hamarosan keresni fog a részletekkel kapcsolatban a következő <br /> telefonszámon: <strong>+36 {phoneNumber}.</strong>',
				coupon: '<br /> Az online kupont kiküldtük az <strong>{email} e-mail címre.</strong>',
			},
		},
		disclaimer: {
			business:
				'Hozzájárulok ahhoz, hogy adataimat az <a href="{url}" target="_blank" rel="noopener noreferrer">Adatkezelési tájékoztató</a>ban meghatározottak szerint a Cég kezelje. Céges ajánlatkérés esetén hozzájárulok a vállalkozásom adatainak megadásához és azoknak a Cég általi kezeléséhez is.',
			consumer:
				'Hozzájárulok ahhoz, hogy adataimat az <a href="{url}" target="_blank" rel="noopener noreferrer">Adatkezelési tájékoztató</a>ban meghatározottak szerint a Cég kezelje.',
		},
		buttons: {
			send: 'Küldés',
		},
	},
};
